/**
 * Asset manifest using Vite glob imports.
 *
 * All assets imported here get content-hashed filenames in production,
 * enabling permanent caching with cache-busting on changes.
 */

// Glob import all sprite PNGs - Vite will hash these in production
const spriteModules = import.meta.glob<string>("./assets/sprites/*.png", {
  eager: true,
  query: "?url",
  import: "default",
});

// Build a map from sprite name to URL
const spriteUrls: Record<string, string> = {};
for (const [path, url] of Object.entries(spriteModules)) {
  // Extract name from path: "./assets/sprites/voyager-pristine.png" -> "voyager-pristine"
  const match = path.match(/\/([^/]+)\.png$/);
  if (match?.[1]) {
    spriteUrls[match[1]] = url;
  }
}

/**
 * Get the URL for a sprite by name.
 * In development: "/src/assets/sprites/voyager-pristine.png"
 * In production: "/assets/voyager-pristine-a1b2c3d4.png"
 */
export function getSpriteUrl(name: string): string {
  const url = spriteUrls[name];
  if (!url) {
    console.warn(`Unknown sprite: ${name}. Available: ${Object.keys(spriteUrls).join(", ")}`);
    return "";
  }
  return url;
}

/**
 * Get all available sprite names.
 */
export function getSpriteNames(): string[] {
  return Object.keys(spriteUrls);
}

// Export individual sprite URLs for direct imports if needed
export const SPRITES = spriteUrls;

// Glob import all sound OGGs - Vite will hash these in production
const soundModules = import.meta.glob<string>("./assets/sounds/*.ogg", {
  eager: true,
  query: "?url",
  import: "default",
});

// Build a map from sound name to URL
const soundUrls: Record<string, string> = {};
for (const [path, url] of Object.entries(soundModules)) {
  // Extract name from path: "./assets/sounds/shoot.ogg" -> "shoot"
  const match = path.match(/\/([^/]+)\.ogg$/);
  if (match?.[1]) {
    soundUrls[match[1]] = url;
  }
}

/**
 * Get the URL for a sound by name.
 * In development: "/src/assets/sounds/shoot.ogg"
 * In production: "/assets/shoot-a1b2c3d4.ogg"
 */
export function getSoundUrl(name: string): string {
  const url = soundUrls[name];
  if (!url) {
    console.warn(`Unknown sound: ${name}. Available: ${Object.keys(soundUrls).join(", ")}`);
    return "";
  }
  return url;
}

/**
 * Get all available sound names.
 */
export function getSoundNames(): string[] {
  return Object.keys(soundUrls);
}

// Export sound URLs
export const SOUNDS = soundUrls;
